import { SvgIcon } from '@material-ui/core'

export const PhotoIcon = ({ style = {}, ...props }) => {
  return (
    <SvgIcon
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      style={{ fill: 'none', ...style }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66699 6.41799C1.66699 5.17453 2.67502 4.1665 3.91847 4.1665C4.56455 4.1665 5.13813 3.75309 5.34244 3.14017L5.41699 2.9165C5.45215 2.81103 5.46973 2.75829 5.48854 2.71151C5.7287 2.11411 6.29148 1.70848 6.93417 1.66955C6.9845 1.6665 7.04009 1.6665 7.15127 1.6665H12.8494C12.9606 1.6665 13.0162 1.6665 13.0665 1.66955C13.7092 1.70848 14.272 2.11411 14.5121 2.71151C14.5309 2.75829 14.5485 2.81103 14.5837 2.9165L14.6582 3.14017C14.8625 3.75309 15.4361 4.1665 16.0822 4.1665C17.3256 4.1665 18.3337 5.17453 18.3337 6.41799V13.4998C18.3337 14.9 18.3337 15.6 18.0612 16.1348C17.8215 16.6052 17.439 16.9877 16.9686 17.2274C16.4339 17.4998 15.7338 17.4998 14.3337 17.4998H5.66699C4.26686 17.4998 3.5668 17.4998 3.03202 17.2274C2.56161 16.9877 2.17916 16.6052 1.93948 16.1348C1.66699 15.6 1.66699 14.9 1.66699 13.4998V6.41799Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0003 13.7498C12.0714 13.7498 13.7503 12.0709 13.7503 9.99984C13.7503 7.92877 12.0714 6.24984 10.0003 6.24984C7.92926 6.24984 6.25033 7.92877 6.25033 9.99984C6.25033 12.0709 7.92926 13.7498 10.0003 13.7498Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
